import React, { SetStateAction } from "react";
import { ILanguage } from "../../../types/language";

export interface StepProps {
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
  setSelectedItem: React.Dispatch<React.SetStateAction<PaymentMethod>>;
  selectedItem: PaymentMethod;
  values: Values;
  updateValues: React.Dispatch<React.SetStateAction<Values>>;
}

export interface IPayoneer {
  payoneerId: string;
}

export interface IPayPal {
  email: string;
}

export interface PaymentMethod {
  id: string;
  type: string;
  isPrimary: boolean;
  accountEnding: string;
  details: IPayoneer | IPayPal;
}

export interface Values {
  data: PaymentMethod[];
  loading: boolean;
  error: string;
}

export enum status {
  paid = "Paid",
  pending = "Pending",
  failed = "Failed",
}

export enum transactionHistory {
  Withdraw = "Withdrawal",
  earning = "Earning",
  Payout = "Payout",
}

export enum Langstat {
  APPROVED = "APPROVED",
  PENDING = "PENDING",
}

export interface langs {
  language: string;
  proficiency: string;
  status: Langstat;
}

export interface lantype {
  language: string;
  proficiency: string;
}

export interface addLanguage {
  languages: lantype[];
  category: category;
}
export enum category {
  TAUGHT = "TAUGHT",
  SPOKEN = "SPOKEN",
}

export interface addLangProps {
  value: addLanguage;
  setValue: React.Dispatch<React.SetStateAction<addLanguage>>;
  handleSubmit: (e: React.FormEvent<HTMLFormElement>, type: string) => void;
  setStep: React.Dispatch<React.SetStateAction<string>>;
  languageList: ILanguage[];
  isLoading: boolean;
}

export interface work {
  organization: string;
  jobRole: string;
  startDate: string;
  endDate: string;
}

export interface education {
  level: string;
  endDate: string;
  startDate: string;
  institution: string;
  fieldOfStudy: string;
}

export interface userProfile {
  aboutYou: string;
  aboutYouAsTeacher: string;
  firstName: string;
  lastName: string;
  otherNames: string;
  email: string;
  youtubeUrl: string;
  interests: string[];
  languagesSpoken: lantype[];
  workExperiences: work[];
  educationalQualifications: education[];
  dpUrl: string;
  otherCertifications: string[];
}

export interface profileProps {
  profileData: userProfile;
  setProfileData: React.Dispatch<React.SetStateAction<userProfile>>;
  handleImage: (e: React.ChangeEvent<HTMLInputElement>) => void;
  preview: string | null;
  editables: (e: any, name: string) => void;
}

// Raw data from backend
export interface RawWorkExperience {
  organization: string;
  jobRole: string;
  startDate: string;
  endDate: string;
}

export type Editables = Record<string, any>;
// Transformed data for your app

export interface editables {
  name: string;
}
